// (B) 플레인 Alert — antd Alert 대체(순수 시각). `.om-alert`/`.om-alert-{type}` hook.
// type 아이콘은 self-contained 인라인 SVG(OmIcon registry/@ant-design/icons 비의존).
// base 시각은 styles/omAlert.css(antd CSS-in-JS 색/레이아웃 파리티).
import type { ReactNode } from 'react'
import type { OmwAlertProps } from '../api/OmwAlert'
import { cx } from './cx'
import '../styles/omwAlert.css'

// antd 파리티 filled 아이콘(24x24 뷰박스, currentColor).
const ICONS: Record<NonNullable<OmwAlertProps['type']>, ReactNode> = {
  success: (
    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H725c6.5 0 10.3 7.4 6.5 12.7z" />
  ),
  info: (
    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" />
  ),
  warning: (
    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" />
  ),
  error: (
    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L653.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" />
  ),
}

export function PlainAlert({
  type = 'info',
  message,
  description,
  showIcon,
  className,
  style,
}: OmwAlertProps) {
  return (
    <div
      role="alert"
      className={cx(
        'om-alert',
        `om-alert-${type}`,
        description != null && 'om-alert-with-description',
        className,
      )}
      style={style}
    >
      {showIcon === true && (
        <span className="om-alert-icon" aria-hidden>
          <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
            {ICONS[type]}
          </svg>
        </span>
      )}
      <div className="om-alert-content">
        <div className="om-alert-message">{message}</div>
        {description != null && <div className="om-alert-description">{description}</div>}
      </div>
    </div>
  )
}
